/* KLIK content pages: showroom open/closed status (Saudi time), FAQ search and topics, gentle reveal on scroll. */
(() => {
  "use strict";
  const root = document.querySelector(".pg");
  if (!root) return;
  const ar = root.getAttribute("dir") === "rtl";

  /* ---------- showroom status ---------- */
  const DAYS = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
  const DAYS_AR = ["الأحد", "الاثنين", "الثلاثاء", "الأربعاء", "الخميس", "الجمعة", "السبت"];
  const mins = (t) => {
    const m = /^(\d{1,2}):(\d{2})$/.exec(t || "");
    return m ? Number(m[1]) * 60 + Number(m[2]) : null;
  };
  const clock = (min) => {
    const h = Math.floor(min / 60) % 24;
    const m = String(min % 60).padStart(2, "0");
    const h12 = h % 12 || 12;
    return ar ? `${h12}:${m} ${h < 12 ? "ص" : "م"}` : `${h12}:${m} ${h < 12 ? "am" : "pm"}`;
  };
  function saudiNow() {
    const parts = Object.fromEntries(
      new Intl.DateTimeFormat("en-US", { timeZone: "Asia/Riyadh", weekday: "long", hour: "2-digit", minute: "2-digit", hourCycle: "h23" })
        .formatToParts(new Date())
        .map((p) => [p.type, p.value]),
    );
    return { day: DAYS.indexOf(parts.weekday), min: Number(parts.hour) * 60 + Number(parts.minute) };
  }
  function slotsFor(store, day) {
    let list;
    try {
      list = JSON.parse(day === 5 ? store.dataset.pgFriday : store.dataset.pgWeek);
    } catch (e) {
      return [];
    }
    return list.map(([o, c]) => ({ open: mins(o), close: mins(c) })).filter((s) => s.open !== null && s.close !== null);
  }
  function status(store, now) {
    const today = slotsFor(store, now.day);
    const current = today.find((s) => now.min >= s.open && now.min < s.close);
    if (current) return { open: true, text: ar ? `مفتوح الآن · حتى ${clock(current.close)}` : `Open now · until ${clock(current.close)}` };
    const later = today.find((s) => s.open > now.min);
    if (later) return { open: false, text: ar ? `مغلق الآن · يفتح ${clock(later.open)}` : `Closed now · opens at ${clock(later.open)}` };
    for (let k = 1; k <= 7; k++) {
      const day = (now.day + k) % 7;
      const first = slotsFor(store, day)[0];
      if (!first) continue;
      const when = k === 1 ? (ar ? "غدًا" : "tomorrow") : ar ? DAYS_AR[day] : DAYS[day];
      return { open: false, text: ar ? `مغلق الآن · يفتح ${when} ${clock(first.open)}` : `Closed now · opens ${when} at ${clock(first.open)}` };
    }
    return null;
  }
  function paint() {
    const now = saudiNow();
    if (now.day < 0) return;
    root.querySelectorAll("[data-pg-store]").forEach((store) => {
      const out = store.querySelector("[data-pg-status]");
      const s = status(store, now);
      if (out && s) {
        out.textContent = s.text;
        out.classList.toggle("is-open", s.open);
        out.hidden = false;
      }
      store.querySelectorAll("[data-pg-days]").forEach((row) => {
        row.classList.toggle("is-today", row.dataset.pgDays.split(",").includes(String(now.day)));
      });
    });
  }
  if (root.querySelector("[data-pg-store]")) {
    paint();
    setInterval(paint, 60000);
  }

  /* ---------- FAQ: search and topics ---------- */
  const faq = root.querySelector("[data-pg-faq]");
  if (faq) {
    const input = faq.querySelector("[data-pg-faq-search]");
    const chips = [...faq.querySelectorAll("[data-pg-chip]")];
    const items = [...faq.querySelectorAll("[data-pg-faq-item]")];
    const groups = [...faq.querySelectorAll(".pg-faq-group")];
    const empty = faq.querySelector("[data-pg-faq-empty]");
    const norm = (s) =>
      s
        .toLocaleLowerCase()
        .normalize("NFKD")
        .replace(/[̀-ًͯ-ٟ]/g, "")
        .replace(/[أإآ]/g, "ا")
        .replace(/ى/g, "ي")
        .replace(/ة/g, "ه");
    items.forEach((item) => (item.dataset.pgText = norm(item.textContent)));
    // the offer question follows the campaign: if the campaign hid it, filtering never shows it
    const offerHidden = (item) => item.hasAttribute("data-kc-show") && item.closest("[data-kc-component]")?.dataset.kcState !== "active";
    let topic = "all";
    const apply = () => {
      const words = norm(input ? input.value : "").split(/\s+/).filter(Boolean);
      let shown = 0;
      items.forEach((item) => {
        const ok = !offerHidden(item) && (topic === "all" || item.dataset.pgGroup === topic) && words.every((w) => item.dataset.pgText.includes(w));
        item.hidden = !ok;
        if (ok) shown++;
        if (words.length && ok && !item.open) {
          item.open = true;
          item.dataset.pgAuto = "1";
        }
        if (!words.length && item.dataset.pgAuto) {
          item.open = false;
          delete item.dataset.pgAuto;
        }
      });
      groups.forEach((g) => {
        g.hidden = !items.some((i) => !i.hidden && i.dataset.pgGroup === g.dataset.pgGroup);
      });
      if (empty) empty.hidden = shown > 0;
    };
    let timer;
    if (input) input.addEventListener("input", () => {
      clearTimeout(timer);
      timer = setTimeout(apply, 120);
    });
    chips.forEach((chip) =>
      chip.addEventListener("click", () => {
        topic = chip.dataset.pgChip;
        chips.forEach((c) => c.setAttribute("aria-pressed", String(c === chip)));
        apply();
      }),
    );
    const fromHash = /^#faq-(\w+)$/.exec(location.hash);
    if (fromHash && chips.some((c) => c.dataset.pgChip === fromHash[1])) chips.find((c) => c.dataset.pgChip === fromHash[1]).click();
  }

  /* ---------- reveal ---------- */
  const reveal = root.querySelectorAll("[data-pg-reveal]");
  if (reveal.length && "IntersectionObserver" in window && !matchMedia("(prefers-reduced-motion: reduce)").matches) {
    document.documentElement.classList.add("pg-motion");
    const io = new IntersectionObserver(
      (entries) =>
        entries.forEach((e) => {
          if (e.isIntersecting) {
            e.target.classList.add("is-in");
            io.unobserve(e.target);
          }
        }),
      { rootMargin: "0px 0px -8% 0px" },
    );
    reveal.forEach((el) => {
      if (el.getBoundingClientRect().top < innerHeight) el.classList.add("is-in");
      io.observe(el);
    });
  }

  /* ---------- contact form (K-060, PACKAGES 3.2): publish klik_contact_submitted on submit ---------- */
  const contactForm = document.querySelector("[data-klik-contact-form]");
  if (contactForm) {
    contactForm.addEventListener("submit", () => {
      try {
        const topic = contactForm.querySelector("[data-klik-contact-topic]");
        const city = contactForm.querySelector("[data-klik-contact-city]");
        window.Shopify?.analytics?.publish?.("klik_contact_submitted", {
          topic: topic ? topic.value : "",
          city: city ? city.value : "",
          lang: ar ? "ar" : "en",
        });
      } catch (e) { /* never block the form */ }
    });
  }
})();
